import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Lock, Unlock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

// Card di sblocco per il ruolo "Visualizzatore": reinserendo la propria
// password sblocca temporaneamente (30 min) allegati, firme e stampe.
export const ViewerUnlockCard = ({
  title = "Area protetta",
  description = "Inserisci di nuovo la tua password per continuare.",
  onUnlocked,
}) => {
  const { unlockView } = useAuth();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!password) {
      toast.error("Inserisci la password");
      return;
    }
    setLoading(true);
    try {
      await unlockView(password);
      toast.success("Sbloccato per 30 minuti");
      onUnlocked?.();
    } catch (e) {
      const msg = e?.response?.data?.detail;
      toast.error(typeof msg === "string" ? msg : "Password errata");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      className="p-6 max-w-md mx-auto text-center space-y-4 border-amber-200"
      data-testid="viewer-unlock-card"
    >
      <div className="h-12 w-12 rounded-full bg-amber-100 grid place-items-center mx-auto">
        <Lock className="h-6 w-6 text-amber-700" />
      </div>
      <div>
        <div className="font-heading font-bold text-lg">{title}</div>
        <p className="text-sm text-slate-500 mt-1">{description}</p>
      </div>
      <Input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && submit()}
        placeholder="La tua password"
        className="h-12"
        data-testid="viewer-unlock-password-input"
      />
      <Button
        onClick={submit}
        disabled={loading}
        className="w-full h-12 bg-[#0044FF] hover:bg-[#0033CC]"
        data-testid="viewer-unlock-button"
      >
        <Unlock className="h-4 w-4 mr-2" />
        {loading ? "Verifica…" : "Sblocca"}
      </Button>
    </Card>
  );
};
